import { colors } from '@vfit/shared/themes';
import { Player } from '@lottiefiles/react-lottie-player';
import { requireStaticImageAtomComponent } from '@vfit/shared/data-access';
import { ImageAtoms } from '@vfit/shared/atoms';
import { ILoading } from './loading.models';
import { Container, NewLoader } from './loading.style';
import { Loader } from '../Loader';

export const Loading = ({ lottieOrSvg }: ILoading) => {
  if (!lottieOrSvg) {
    return (
      <NewLoader>
        <Loader color={colors.$e60000} />
      </NewLoader>
    );
  }
  if (!lottieOrSvg?.includes('json')) {
    return (
      <Container>
        <ImageAtoms nameCard="image_loader" image={lottieOrSvg} />
      </Container>
    );
  }
  return (
    <Container>
      <Player
        src={requireStaticImageAtomComponent(lottieOrSvg).src}
        className="player"
        loop
        autoplay
      />
    </Container>
  );
};
